export default "__VITE_ASSET__9nlASm3A__"